import React from 'react';
import { connect } from 'react-redux';
import { getCatalogEntry } from 'reducers/app';
import { State } from 'typings/state';
import { SelectCatalogButton } from './SelectCatalogButton';
import { ISelectCatalogButtonContainerProps } from './SelectCatalogButton.types';
import { showModal } from 'actions/GuiActions';
import { Action } from 'typings/actions';
import { ModalType } from 'typings/enums';

const mapStateToProps = (state: State, ownProps: ISelectCatalogButtonContainerProps) => ({
  ...ownProps,
  catalogEntry: ownProps.catalogEntryId && getCatalogEntry(state, ownProps.catalogEntryId),
  modalState: state.gui.modal,
});
const mapDispatchToProps = (
  dispatch: (action: Action) => void,
  ownProps: ISelectCatalogButtonContainerProps
) => {
  return {
    onOpenModal: (content: any) =>
      dispatch(showModal(ModalType.INFO, content, 'Katalogeintrag-Details')),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SelectCatalogButton) as React.FC<ISelectCatalogButtonContainerProps>;
